import React from 'react';
import smoothScroll from 'smoothscroll';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Card from 'components_v2/common/CardV2/Card';
import AffiliatesContent from 'components/AffiliatesContent';

//import LiveBlogLHSSticky from '../LiveBlogLHSSticky/LiveBlogLHSSticky';
import s from './NextArticlesLHS.scss';

class NextArticlesLHSv2 extends React.Component {
  // isIndiaSection = (this.props.sectionName &&
  //   this.props.sectionName.toLowerCase() === 'india')
  isIndiaSection = true;

  getListHtml(val, dataPresent, index) {
    let tnname = 'news';
    if (
      this.isIndiaSection &&
      this.props.articleShowData &&
      val.msid &&
      this.props.articleShowData[val.msid] &&
      this.props.articleShowData[val.msid].hasVideo &&
      this.props.articleShowData[val.msid].hasVideo === 'yes'
    ) {
      tnname = 'video';
    }
    let imageid = val?.hasThumb === false ? '25581306' : val.msid;
    let imagesize = '12345';
    if (Array.isArray(val.images) && val.images.length > 0) {
      imageid = val?.images[0]?.id;
      imagesize = val?.images[0]?.imagesize;
    }
    return (
      <li
        className={`${s.list_item} ${
          val.msid === this.props.activeMsid ? s.active : ''
        } ${!dataPresent ? s.disabled : ''}`}
      >
        {this.isIndiaSection ? (
          <Card
            data={{
              hl: val.value,
              imageid,
              imagesize,
              id: val.msid,
              tn: tnname,
              wu: val.wu,
            }}
            imgWidth="170"
            onClick={e =>
              this.goToArticle(val.msid, dataPresent, e, index, val.wu)
            }
          />
        ) : (
          <Link
            href={val.wu}
            className={s.list_link}
            onClick={e =>
              this.goToArticle(val.msid, dataPresent, e, index, val.wu)
            }
          >
            <span>{val.value}</span>
          </Link>
        )}
      </li>
    );
  }

  goToArticle = (msid, dataPresent, e, index, wu) => {
    e.preventDefault();
    if (!dataPresent || msid === this.props.activeMsid) {
      return;
    }
    const elem = document.querySelector(`[data-articlemsid="${msid}"]`);
    const categoryForGA =
      typeof window !== 'undefined' && window.categoryForGA
        ? window.categoryForGA
        : '';
    const { isEtimesArticle } = this.props;
    //const { isSticky } = this.state;
    if (elem) {
      sendGaThroughProps({
        data: {
          //gaCategory: `LHS${isSticky ? '_sticky' : ''}_${index}`,
          gaCategory: `${categoryForGA}`,
          gaAction: isEtimesArticle ? 'click-LHS-story' : 'upNext_scroll',
          gaLabel: isEtimesArticle ? `${index}-${wu}` : `story_${index}-${wu}`,
        },
      });
      const elemTop = elem.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const top = elemTop.top + scrollTop;
      smoothScroll(top - 50, 700, () =>
        this.props.changeActiveArticle(msid, index),
      );
    }
  };

  render() {
    const { styleObj, nextStories, isValidToShowAffiliateWidget } = this.props;
    return (
      <div className={`${styleObj.nextASwidget} nextASwidget`}>
        <div className="refDiv" />
        <div className="lhsSticky">
          <div className={this.isIndiaSection ? [`${s.cardListItems}`] : ''}>
            <div className={`${s.nextarticle_wrapper}`}>
              <h4>You&apos;re reading</h4>
              <ul className={s.list}>
                {this.getListHtml(this.props.currentStory, true, 1)}
                {nextStories &&
                  nextStories.length &&
                  nextStories.map((val, index) => (
                    <React.Fragment key={val.msid}>
                      {this.getListHtml(
                        val,
                        !!(
                          this.props.articleShowData &&
                          this.props.articleShowData[val.msid]
                        ),
                        index + 2,
                      )}
                    </React.Fragment>
                  ))}
              </ul>
              {isValidToShowAffiliateWidget && (
                <AffiliatesContent
                  type="inline_sale_nudge"
                  // enableWidgetsOnLoad
                  filters={{
                    pagename: 'any',
                  }}
                  loadingComponent={<></>}
                  componentProps={{
                    config: {
                      ga: {
                        category: 'WEB_articleshowv2',
                      },
                    },
                  }}
                  onContentLoaded={() => {
                    this.props.setSaleNudgeVisibilityFn(true);
                  }}
                  noShowCallback={() => {
                    this.props.setSaleNudgeVisibilityFn(false);
                  }}
                />
              )}
            </div>
          </div>
          <div className={s.blankLhs} />
          {/* {(this.props.sectionName.toLowerCase() === 'city' ||
            this.props.sectionName.toLowerCase() === 'india') && (
            <LiveBlogLHSSticky articleMsid={this.props.msid} />
          )} */}
        </div>
      </div>
    );
  }
}

NextArticlesLHSv2.propTypes = {
  nextStories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeMsid: PropTypes.string,
  currentStory: PropTypes.shape({}).isRequired,
  articleShowData: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  changeActiveArticle: PropTypes.func.isRequired,
  styleObj: PropTypes.shape({}),
  isValidToShowAffiliateWidget: PropTypes.bool,
  setSaleNudgeVisibilityFn: PropTypes.func.isRequired,
  isEtimesArticle: PropTypes.bool,
  //sectionName: PropTypes.string,
  //msid: PropTypes.string,
};

NextArticlesLHSv2.defaultProps = {
  activeMsid: '',
  styleObj: {},
  isValidToShowAffiliateWidget: true,
  isEtimesArticle: false,
  // sectionName: 'city',
  // msid: '12345',
};

export default NextArticlesLHSv2;
